module.exports = __webpack_public_path__ + "img/SVG1_Estimate.a9b4d768.svg";